export const GUESTS_UPDATE_TITLE = 'Actualización de Visitados';
export const CLOSING_HOUR = 'Hora de Cierre';
export const SELECT = 'Seleccione';
export const HOUR = 'Hora';
export const MINUTE = 'Minuto';
export const SAVE = 'Guardar';
export const GUESTS_UPDATE_SAVED = 'Se ha configurado correctamente la actualización de visitados';
export const GUESTS_UPDATE_FAIL = 'Hubo un problema al configurar actualización de visitados';
export const FETCH_GUESTS_UPDATE_FAIL = 'Hubo un problema al cargar la actualización de visitados';
